var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isEditable)?_c('CostableTableRow',{staticClass:"position-relative pointer",attrs:{"is-heading-row":true},on:{"click":_vm.addNewCost},scopedSlots:_vm._u([{key:"heading",fn:function(){return [_c('span',{staticClass:"text-muted font-italic"},[_vm._v("\n            Add another item...\n        ")])]},proxy:true}],null,false,182997504)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }